module.exports = __webpack_public_path__ + "static/media/1.7c275af1.jpg";